import { cn } from '@/utils/index';
import * as React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  isError?: boolean;
}

const Input = ({ className, type, endIcon, startIcon, isError, disabled, ...props }: InputProps) => {
  const hasError = props['aria-invalid'] === true || !!isError;

  const endIcons = React.useMemo(() => {
    const content = [];

    if (endIcon) {
      content.push(<span key='input-end-icon'>{endIcon}</span>);
    }

    return content;
  }, [endIcon]);

  return (
    <div className='relative'>
      <input
        type={type}
        className={cn(
          'group peer',
          'rounded-input border-outline-input-default file:text-text-default-primary placeholder:text-text-default-primary/60 text-body-m-regular flex h-12 w-full border px-4 py-3 file:border-0 file:bg-transparent file:font-semibold disabled:cursor-not-allowed disabled:opacity-60',
          'hover:border-outline-input-hover',
          'focus-visible:border-outline-focus focus-visible:border-2 focus-visible:px-[15px] focus-visible:py-[11px] focus-visible:outline-hidden',
          !!startIcon && 'pl-11 focus-visible:pl-[43px]',
          endIcons.length === 1 && 'pr-11 focus-visible:pr-[43px]',
          hasError && 'border-outline-error border-2 px-[15px] py-[11px]',
          !!startIcon && hasError && 'pl-[43px]',
          endIcons.length === 1 && hasError && 'pr-[43px]',
          endIcons.length === 2 && 'pr-[67px]',
          className,
        )}
        disabled={disabled}
        {...props}
      />
      {startIcon && <div className='text-text-default-secondary absolute top-0 left-3 flex h-full items-center peer-disabled:opacity-80'>{startIcon}</div>}
      {endIcons.length > 0 && (
        <div className='text-text-default-secondary absolute top-0 right-4 flex h-full items-center gap-1 peer-disabled:opacity-80'>{endIcons}</div>
      )}
    </div>
  );
};
Input.displayName = 'Input';

export { Input };
